import { render, staticRenderFns } from "./PaginationNavigation.vue?vue&type=template&id=6a5aa336&"
import script from "./PaginationNavigation.vue?vue&type=script&lang=js&"
export * from "./PaginationNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PaginationNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports